<div>
    <div class="flex flex-row" style="width: 100%; align-items: center;">
        <button mat-icon-button class="btn btn-link btn-sm custom" (click)="toggleExpanded()">
            <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div class="user-accounts">
            {{ (!loggedInUserAccounts || loggedInUserAccounts.length === 0) ? '' : loggedInUserAccounts[0].clientName }}
        </div>
        <mat-chip *ngIf="checkedAccountsCount > 0" class="checked-accounts-chip" style="margin-left: 12px;">
            {{checkedAccountsCount}} account{{ checkedAccountsCount === 1 ? '' : 's' }} assigned
        </mat-chip>
    </div>
</div>
<div *ngIf="isExpanded" class="content" style="padding-left: 4%;">
    <table style="table-layout: fixed;" mat-table [dataSource]="loggedInUserAccounts">
        <!-- Account Access Column -->
        <ng-container matColumnDef="accountAccess">
            <th mat-header-cell *matHeaderCellDef style="width:60%; ">Account Access</th>
            <td style="width: 60%;border-bottom: none; padding-right: 30%;" mat-cell *matCellDef="let account">
                <div style="display: flex; align-items: center;">
                    <mat-checkbox *ngIf="!isReadOnly" id="{{ account.id }}"  [disabled]="!canUpdateAccounts" (change)="onAccountCheckboxChange($event, account.clientId)" [checked]="userHasAccountAccess(account.id)"></mat-checkbox>
                    <span>{{ account.name + ' (' + account.code + ')' }}</span>
                </div>
            </td>
        </ng-container>

        <!--Distribution Toggle Column-->
        <ng-container matColumnDef="distribution">
            <th mat-header-cell *matHeaderCellDef style="width:10%;">Distribution</th>
            <td style="width:10%;border-bottom: none" mat-cell *matCellDef="let account">
                <mat-slide-toggle [disabled]="isReadOnly || !userHasAccountAccess(account.id)" (change)="toggleAccountDistribution($event, account)" [checked]="userIsOnDistributionForAccount(account.id)" />
            </td>
        </ng-container>

        <!--CoSign Toggle Column-->
        <ng-container matColumnDef="cosign">
            <th mat-header-cell *matHeaderCellDef style="width:10%;">Co-Sign</th>
            <td style="width:10%;border-bottom: none" mat-cell *matCellDef="let account">
                <mat-slide-toggle [disabled]="isReadOnly || !userHasAccountAccess(account.id)" (change)="toggleAccountCoSign($event, account)" [checked]="userIsOnForCoSignForAccount(account.id)" />
            </td>
        </ng-container>

        <!--Approval Limit Column-->
        <ng-container matColumnDef="approval-limit">
            <th mat-header-cell *matHeaderCellDef style="width:12%;">Approval limit</th>
            <td style="width:12%;max-width:200px;border-bottom: none" mat-cell *matCellDef="let account">
                <mat-form-field appearance="fill" style="width: 100%; margin: 0;">
                    <input matInput [maskito]="maskitoOptions" [disabled]="isReadOnly || !userHasAccountAccess(account.id)" min="0" [value]="userApprovalLimitForAccountFormatted(account.id)" (focus)="onFieldFocus($event)" (blur)="updateApprovalLimit($event, account)" (wheel)="onWheel($event)">
                </mat-form-field>
            </td>
        </ng-container>

        <!--Case Limit Column-->
        <ng-container matColumnDef="case-limit">
            <th mat-header-cell *matHeaderCellDef style="width:3%;">Case Limit</th>
            <td style="width:3%;max-width:120px;border-bottom: none" mat-cell *matCellDef="let account">
                <mat-form-field appearance="fill" style="width: 100%; margin: 0;">
                    <input matInput [disabled]="isReadOnly || !userHasAccountAccess(account.id)" min="0" type="number" [placeholder]="userHasAccountAccess(account.id) ? 'Unlimited' : ''" [value]="userCaseLimitForAccount(account.id) === null ? '' : userCaseLimitForAccount(account.id)" (focus)="onFieldFocus($event)" (blur)="updateCaseLimit($event, account)" (wheel)="onWheel($event)">
                </mat-form-field>
            </td>
        </ng-container>
        <!-- Table Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- Data Rows -->
        <tr mat-row *matRowDef="let account; columns: displayedColumns;"></tr>
      
      </table>
</div>
